import { createApp } from 'vue';
import app from './views/app.vue';
import './register-service-worker';
import router from './router';
import store from './store';
import { sync } from 'vuex-router-sync';

sync(store, router);

createApp(app).use(store).use(router).use(store).mount('#app');
